export const File_Labels = {
   bmp:"Bitmap(.bmp)",
    csv:"Comma Separated Values(.csv)",
    djvu:"DjVu[Deja Vu](.djvu)",
    doc: "Microsoft Word (.doc)",
    docx: "Microsoft Word (.docx)",
    dot:"Mircosoft Word (.dot)",
    dotx:"Mircosoft Word(.dotx)",
    dwf:"AutoDesk-Design Web Format(.dwf)",
    dwfx:"AutoDesk-Design Web Format(.dwf)",
    dwg:"CAD:Drawing(.dwg)",
    dxf:"AutoDesk:Drawing Exchange Format(.dxf)",
    eml:"Email(.eml)",
    eps:"Encapsulated PostScript(.eps)",
    epub:"Electronic Publication(.epub)",
    gif:"Graphics Interchange Format(.gif)",
    heic:"High Efficiency Image Container(.heic)",
    heif:"High Efficiency Image File Format(.heif)",
    htm:"Hypertext Markup Language(.htm)",
    ico:"Image container in Microsoft Windows(.ico)",
    jfif: "JPEG File Interchange Format (.jfif)",
    jpg: "JPEG Image (.jpg)",
    jpeg: "JPEG Image (.jpeg)",
    png: "Portable Network Graphics (.png)",
    key: "Apple Keynote Presentation (.key)",
    pages: "Apple Pages Document (.pages)",
    numbers: "Apple Numbers Spreadsheet (.numbers)",
    log: "Log File (.log)",
    md: "Markdown Document (.md)",
    msg: "Outlook Email Message (.msg)",
    mobi: "Mobipocket eBook (.mobi)",
    odc: "OpenDocument Chart (.odc)",
    odf: "OpenDocument Formula (.odf)",
    odg: "OpenDocument Graphics (.odg)",
    odp: "OpenDocument Presentation (.odp)",
    ods: "OpenDocument Spreadsheet (.ods)",
    odt: "OpenDocument Text (.odt)",
    potx: "PowerPoint Template (.potx)",
    pps: "PowerPoint Slideshow (.pps)",
    ppsx: "PowerPoint Slideshow (.ppsx)",
    ppt: "PowerPoint Presentation (.ppt)",
    pptx: "PowerPoint Presentation (.pptx)",
    prn: "Printer File (.prn)",
    ps: "PostScript File (.ps)",
    psd: "Photoshop Document (.psd)",
    pub: "Publisher Document (.pub)",
    rtf: "Rich Text Format (.rtf)",
    svg: "Scalable Vector Graphics (.svg)",
    tif: "Tagged Image File (.tif)",
    tiff: "Tagged Image File (.tiff)",
    txt: "Text File (.txt)",
    vsd: "Visio Diagram (.vsd)",
    vsdx: "Visio Diagram (.vsdx)",
    webp: "WebP Image (.webp)",
    wpd: "WordPerfect Document (.wpd)",
    xls: "Excel Spreadsheet (.xls)",
    xlsb: "Excel Binary Workbook (.xlsb)",
    xlsx: "Excel Spreadsheet (.xlsx)",
    xltx: "Excel Template (.xltx)",
}

export const File_Desc={
    bmp:"An image format devoloped by Microsoft-format used specfically for Windows applications.",
    csv:"A plain text file that stores structured tabular data - very similar to Excel files. ",
    djvu:"A computer file format that is used specfically for scanned documents.",
    doc: "A legacy Microsoft Word document — widely used before .docx became standard.",
    docx: "A modern Microsoft Word document — widely supported across most word processors today.",
    dot:"A legacy Microsoft Word template document - used as a blueprint for doc and docx before dotx became standard.",
    dotx:"A moderm Microsoft Word template document- used a blueprint for doc and docx files.",
    dwf:" A secure, highly compressed file format developed by Autodesk for efficient sharing, viewing, and printing of 2D/3D CAD design data.",
    dwfx:"Autodesk Design Web Format (DWF) file that uses Microsoft's XML Paper Specification (XPS), allowing 2D/3D design data to be shared, viewed, and printed easily across different platforms.",
    dwg:"A proprietary binary file format used for storing 2D and 3D design data, metadata, and vector graphics, acting as the native file format for AutoCAD and other CAD applications.",
    dxf:"An open-source vector file format created by Autodesk for sharing 2D and 3D design data between different CAD (Computer-Aided Design) applications.",
    eml:"A standard, plain-text file format used to store individual email messages, including headers (sender, recipient, date, subject) and body content (HTML or plain text), along with attachments.",
    eps:"a standard,vector-based graphic file format used primarily for high-resolution printing, vector illustrations, and logos.",
    epub:"The standard format for digital books.",
    gif:"A bitmap image format from 1987 known for short, looping animations and simple graphics.It is quite standard in modern times.",
    heic:"The default image format for newer Apple Devices- storing high-quality images in roughly half the storage space of JPEGs.",
    hief:"A modern container for single images or sequences, offering better compression than JPEG while maintaining quality.",
    htm:"A plain text document containing code that web browsers interpret to display web pages, structuring text, images, links, and other media.",
    html:"Standard everywhere, it is a plain text document that contains code which web browsers use to display webpages.",
    ico:" a specialized image container used by Microsoft Windows to store one or more small, multi-resolution, and multi-color-dSepth icons.",
    jfif: "An image file format based on the JPEG standard, commonly used for storing compressed photographic images.",
    jpg: "A widely used compressed image format ideal for photographs and web images.",
    jpeg: "A standard compressed image format commonly used for digital photos and online images.",
    png: "A lossless image format that supports transparency and is commonly used for web graphics.",
    key: "A presentation file format used by Apple Keynote for creating slideshows.",
    pages: "A document file format used by Apple Pages for word processing.",
    numbers: "A spreadsheet file format used by Apple Numbers for data organization and analysis.",
    log: "A text-based file used to record system events, errors, or application activity.",
    md: "A lightweight markup text format used for formatting documentation and README files.",
    msg: "An email message file format used by Microsoft Outlook to store individual emails.",
    mobi: "An eBook file format commonly used by older Amazon Kindle devices.",
    odc: "An OpenDocument file format used to store charts created in office applications.",
    odf: "An OpenDocument file format used to store mathematical formulas.",
    odg: "An OpenDocument file format used for vector graphics and drawings.",
    odp: "An OpenDocument file format used for presentation slides.",
    ods: "An OpenDocument file format used for spreadsheets and tabular data.",
    odt: "An OpenDocument file format used for text documents.",
    potx: "A Microsoft PowerPoint template file used as a starting layout for presentations.",
    pps: "A Microsoft PowerPoint slideshow file that opens directly in presentation mode.",
    ppsx: "A newer PowerPoint slideshow file format that opens directly in presentation mode.",

    //manjari
    pptx: "The modern PowerPoint format used for creating and sharing presentations.",
    prn: "A printer output file containing formatted print instructions.",
    ps: "A PostScript file used for high-quality printing and publishing.",
    psd: "A Photoshop file that stores layered images and design edits.",
    pub: "A Microsoft Publisher file used for brochures, flyers, and layouts.",
    rtf: "A text document format that preserves basic formatting across platforms.",
    svg: "A vector image format that scales without losing quality.",
    tif: "A high-quality image format commonly used in scanning and publishing.",
    tiff: "A high-quality image format commonly used in scanning and publishing.",
    txt: "A plain text file with no formatting.",
    vsd: "An older Microsoft Visio format used for diagrams and flowcharts.",
    vsdx: "The modern Visio format used for diagrams and technical drawings.",
    webp: "A modern image format optimized for smaller file sizes and web use.",
    wpd: "A WordPerfect document format used in older word processing systems.",
    xls: "An older Excel spreadsheet format for storing data and formulas.",
    xlsb: "A binary Excel format optimized for large and complex spreadsheets.",
    xlsx: "The modern Excel spreadsheet format widely used today.",
    xltx: "An Excel template file used to create new spreadsheets with preset layouts.",    
}